module.exports = __webpack_public_path__ + "img/48.a7d25f2a.a7d25f2a.svg";